import type { Router } from 'next/router'

export const isPaymentDialogInQuery = (query: Router['query']) => {
  const hasPaymentEntityIdInQuery = 'transfer_id' in query || 'reconciliation_item_id' in query
  const hasPaymentTypeInQuery = 'payment_dialog' in query

  return hasPaymentEntityIdInQuery && hasPaymentTypeInQuery
}
